// export const BASE_API_URL='http://localhost:8089';
// export const BASE_WEB_URL='http://localhost:3000/';

export const BASE_API_URL='https://api.nusic.pro:8444';
export const BASE_WEB_URL='https://marketplace-web-indol.vercel.app/';

export const WEB3STORAGE_TOKEN = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJkaWQ6ZXRocjoweDcxODBiOTM1QTU5ZjI2OTFlNEIyZTcyZmJkNzBBNmMyNjQzMzQ1ZjMiLCJpc3MiOiJ3ZWIzLXN0b3JhZ2UiLCJpYXQiOjE2NjA5MTc5ODUxODYsIm5hbWUiOiJudXNpY19uZnQifQ.BcXXoJz43nxZ1nK1lLEH7YeXKpdzQuJ5HmGqMyTHTLw';

// Kovan
// export const NFT_ADDRESS = '0x99f66E4881D37E2E8ca5F8c4F426F1295f54d306';
// export const SP_TOKEN_FACTORY = '0xB346E5D613965cB36D140068D7C494BAce3BDb80';
// export const STAKING_TOKEN = '0xcAd78BFCE45549214EA2F68dc1f3E6DB9D8F8792';// kovan testnet
// export const MARKETPLACE_ADDRESS = '0x6c6653b5718cdd469ab511ad42cca9ccb42941df';
// export const PAYMENT_TOKEN = '0xcbd5e761a9fa52dab3685d4fd58c804e1f20a59c';// USDT
// export const PANCAKE_ROUTER = '0x10ED43C718714eb63d5aA57B78B54704E256024E';//pancake V2 router
// export const NUSIC_VAULT = '';
// export const ALLOCATION_ADDRESS = '';// Allocation address
// export const ETHER_SCAN_URL = "https://kovan.etherscan.io/";
// export const CHAIN_ID = 42;

// bsc testnet
// export const NFT_ADDRESS = '0xf43C615C68ef1b572809f937fcbd37eCd2327956';
// export const STAKING_TOKEN = '0x02868877Ed45246124f89B3cc54Ee53DDe49A85B';// Nusic on testnet
// export const PAYMENT_TOKEN = '0xf09789E18E821bb8FFAf65D2547fB05589058BBf';// USDT
// export const PANCAKE_ROUTER = '0x9Ac64Cc6e4415144C455BD8E4837Fea55603e5c3';//pancake V2 router
// export const SP_TOKEN_FACTORY = '0x91594A4F16Be034D3eeb09F6e208b63e4be4A77f'
// export const ALLOCATION_ADDRESS = '0xfD57da31D67bBCFd7C0e87470A84F2B8F5552d6A';// Allocation address
// export const NUSIC_VAULT = '0xeCd12d058528638daA6E0195B059bC80Da3E96Cd';// Nusic Vault
// export const MARKETPLACE_ADDRESS = '0x8CeDc5c1B12a9201Cc264a69a02fdD3A68b64496'; // new contract, update matchOrder2
// export const SPTOKEN_VAULT= '0x5F146f51165c705ab41Eb330609989716D0EF9aA'; // SPTokenVault

// Main net
export const NFT_ADDRESS = '0xBE0B8Ec087A8d1440af9FB65936d8B7641639F1e';
export const STAKING_TOKEN = '0x7E58a5c150B3C9171100FDeE0Dd22Ee666dB9545';
export const PAYMENT_TOKEN = '0x55d398326f99059fF775485246999027B3197955';// USDT
export const PANCAKE_ROUTER = '0x10ED43C718714eb63d5aA57B78B54704E256024E';//pancake V2 router
export const SP_TOKEN_FACTORY = '0xf8f48bb987060635591c9fC6fa8080428994FC93'
export const ALLOCATION_ADDRESS = '0x5F2bcE8469c19f3980ACB7827315F20e15561dA9';// Allocation address
export const NUSIC_VAULT = '0x72b6B7e007002524f776c41C3C2f380D3d389095';// Nusic Vault
export const MARKETPLACE_ADDRESS = '0x4988F2D2cB26F3440b6591ca9865Ca4CbeD2BD36'; // new contract, update matchOrder2
export const SPTOKEN_VAULT= '0x232fe364F208C31dea6aD93a9D8f69757db55c29'; // SPTokenVault

export const SHARE_PROFIT_SPT_HOLDERS = 30;
export const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000';
export const ETHER_SCAN_URL = "https://bscscan.com/";
export const CHAIN_ID = 56;

export const STAKING_TOKEN_SYMBOL = "NUSIC";
export const SP_TOKEN_SYMBOL = 'SPT';
export const PAYMENT_TOKEN_SYMBOL = 'USDT';

export const MAX_COVER_IMAGE_SIZE = 5120;
export const MAX_TRACK_FILE_SIZE = 20480;
export const MAX_TIMESTAMP = '2240711999';

export const DEFAULT_COLLECTION_ID = 1;
export const DEFAULT_CATEGORY_ID = 26;
export const SP_TOKEN_WEIGHT = 0.7;
export const DECIMAL = 1e18;
export const NFT_ONSALE_MIN_SCORE = 0;
export const COOKIE_TIMEOUT = 60; // minutes
export const PAGE_SIZE = 18;
export const PANCAKE_FEE_RATE = 0.00; // Fee rate for pancake testnet
export const SLIPPAGE_RATE = 0.04; 
export const VERSION = "0.12.12(beta)";

export const IPFS_GATEWAY = 'https://[cid].ipfs.w3s.link/[content]';// "https://ipfs.io/ipfs/"

export const HEADER_BACKGROUND_IMAGE = "./images/2.jpg";
export const FOOTER_BACKGROUND_IMAGE = "./images/1.jpg";
export const MAIN_COLOR = "#ff01b4";

export const AUDIO_COLORS = [{
	name: "blue",
	color: "#5d5fef",
}, {
	name: "purple",
	color: "#a701ff",
}, {
	name: "orange",
	color: "#fb7d4c",
}, {
	name: "cyan",
	color: "#0cd9fa",
}]